import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { smartThingsService } from '../../../services/smartThingsService';
import { CSpinner, CAlert } from '@coreui/react';
import { toast } from 'react-toastify';
import { ActiveLinkContext } from '../../../components/ActiveLinkContext'; // Ensure this import is correct

const OAuthCallback = () => {
      const navigate = useNavigate();
      const location = useLocation();
      const [status, setStatus] = useState('processing');
      const [error, setError] = useState(null);
      const { setActiveLink } = useContext(ActiveLinkContext);

      useEffect(() => {
            const handleCallback = async () => {
                  try {
                        const params = new URLSearchParams(location.search);
                        const code = params.get('code');

                        console.log('Received authorization code:', code);

                        if (!code) {
                              throw new Error('No authorization code received');
                        }

                        setStatus('exchanging');
                        await smartThingsService.exchangeCodeForToken(code);

                        console.log('Token exchange successful');

                        setStatus('success');
                        toast.success('Successfully connected to SmartThings!');

                        setTimeout(() => {
                              setActiveLink('hadevices');
                              navigate('/homeassistant');
                        }, 1500);

                  } catch (err) {
                        console.error('OAuth callback error:', err);
                        setError(err.message || 'Failed to connect to SmartThings');
                        setStatus('error');
                        toast.error('Failed to connect to SmartThings');
                  }
            };

            handleCallback();
      }, [location, navigate, setActiveLink]);

      const renderContent = () => {
            switch (status) {
                  case 'error':
                        return (
                              <CAlert color="danger">
                                    <h4>Authentication Error</h4>
                                    <p>{error}</p>
                                    <button
                                          className="btn btn-primary mt-3"
                                          onClick={() => {
                                                setActiveLink('hadevices');
                                                navigate('/dashboard');
                                          }}
                                    >
                                          Return to Home Assistant
                                    </button>
                              </CAlert>
                        );
                  case 'success':
                        return (
                              <CAlert color="success">
                                    <h4>Successfully Connected!</h4>
                                    <p>Redirecting to Home Assistant...</p>
                              </CAlert>
                        );
                  default:
                        return (
                              <div className="text-center">
                                    <CSpinner color="primary" />
                                    <p className="mt-3">
                                          {status === 'processing' ? 'Processing authorization...' : 'Exchanging tokens...'}
                                    </p>
                              </div>
                        );
            }
      };

      return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                  <div className="text-center">
                        {renderContent()}
                  </div>
            </div>
      );
};

export default OAuthCallback;